export default __webpack_public_path__ + "static/events-light-9202d603f1463e2b098c864ef6875add.png";